import { createEffect } from 'effector'

export class Logger {
  constructor(
    public readonly prefix = '',
    public readonly writer = globalThis.console
  ) {}

  prepend = (data: unknown[]): unknown[] => {
    const prefixStyle = 'color:gray;font-weight:normal;font-size:0.8em;'
    if (data.length > 0) {
      if (typeof data[0] === 'string' && data[0].includes('%')) {
        data[0] = `%c${this.prefix} ${data[0]}`
        data.splice(1, 0, prefixStyle)
      } else {
        data.unshift(`%c${this.prefix}`, prefixStyle)
      }
    }
    return data
  }

  log = (...data: unknown[]): void => {
    this.writer.log(...this.prepend(data))
  }

  info = (...data: unknown[]): void => {
    this.writer.info(...this.prepend(data))
  }

  warn = (...data: unknown[]): void => {
    this.writer.warn(...this.prepend(data))
  }

  error = (...data: unknown[]): void => {
    this.writer.error(...this.prepend(data))
  }

  debug = (...data: unknown[]): void => {
    this.writer.debug(...this.prepend(data))
  }

  group = (...data: unknown[]): void => {
    this.writer.group(...this.prepend(data))
  }

  groupCollapsed = (...data: unknown[]): void => {
    this.writer.groupCollapsed(...this.prepend(data))
  }

  groupEnd = (): void => {
    this.writer.groupEnd()
  }

  // effector extension
  logFx = createEffect((data: unknown[]) => this.log(...data))
  infoFx = createEffect((data: unknown[]) => this.info(...data))
  warnFx = createEffect((data: unknown[]) => this.warn(...data))
  errorFx = createEffect((data: unknown[]) => this.error(...data))
  debugFx = createEffect((data: unknown[]) => this.debug(...data))
}

// default application logger instance
export const logger = new Logger('uvo')
